import { UserDto } from "@exibra/shared";
import { ColumnDef } from "@tanstack/react-table";

export const usersTableConfig: ColumnDef<UserDto>[] = [
    {
        id: "name",
        header: "Name",
        cell: ({ row }) => row.original.name,
    },
    {
        id: "email",
        header: "Email",
        cell: ({ row }) => row.original.email,
    },
];
